import type { WorkflowUserStateDto } from "@models/data/workflowUserStateDto";
import type { WorkflowRunState } from "./WorkflowDocument";

export interface WorkflowUserStateIdentity {
  readonly accountId: string;
  readonly userId: string;
  readonly projectId: string;
  readonly workflowId: string;
}

/**
 * Durable mutable workflow progress for one authenticated user.
 * Authored workflow content remains owned by the per-project S3 YAML.
 */
export interface IWorkflowUserStateService {
  getAsync(
    identity: WorkflowUserStateIdentity,
    signal?: AbortSignal,
  ): Promise<WorkflowUserStateDto | null>;

  putAsync(
    identity: WorkflowUserStateIdentity,
    state: WorkflowRunState,
    signal?: AbortSignal,
  ): Promise<void>;

  /** Waits for accepted writes and retries the newest failed replacement. */
  flushPending(): Promise<void>;

  dispose(): Promise<void>;
}

export const WORKFLOW_USER_STATE_SERVICE = Symbol.for("Campfire.WorkflowUserStateService");
